import React, { useEffect } from 'react'
import { getVideoLink } from '@/services/NFCGameOn/NFCGameOn'
import { Spin } from 'antd'

const NFCGameOn = () => {
  const [videoLink, setVideoLink] = React.useState('')
  const [videoType, setVideoType] = React.useState('video/mp4')
  const [loading, setLoading] = React.useState(true)
  useEffect(() => {
    // 获取视频链接
    setLoading(true)
    getVideoLink()
      .then(res => {
        console.log('获取视频链接结果:', res)
        if (!res || !res.data || res.data.size === 0) {
          openNikeCom()
          return
        }
        getUrl(res)
        setLoading(false)
      })
      .catch(err => {
        setLoading(false)
        openNikeCom()
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getUrl = resultData => {
    const videoUrl = URL.createObjectURL(resultData.data)
    const type = resultData.headers
      .get('content-disposition')
      .split(';')[1]
      .split('=')[1]
      .replace(/"/g, '') // 去掉引号
      .split('.')[1]
    setVideoLink(videoUrl)
    setVideoType(`video/${type}`)
  }

  const openNikeCom = () => {
    window.open('https://www.nike.com', '_blank')
  }

  return (
    <Spin size="large" tip="视频加载中" spinning={loading} style={{ top: '50%', transform: 'translateY(-50%)' }}>
      <div style={{ width: '100vw', height: '100vh' }}>
        {videoLink && (
          <video controls style={{ width: '100%', height: '100%' }}>
            <source src={videoLink} type={videoType} />
            您的浏览器不支持 video 标签。
          </video>
        )}
      </div>
    </Spin>
  )
}

export default NFCGameOn
